import { Accordion, AccordionTab } from "primereact/accordion"
import { useAppSelector } from "../../../stateManagement/hooks/redux"
import { configureObjectsInfoTree, configureObjectTypesTreeNodes } from "./configureObjectsInfoStructure"
import { objectsInfoAccordionHeaderTemplate, objectTypesTreeNodeTemplate } from "./templates"
import { Tree, TreeEventNodeEvent } from "primereact/tree"
import { useNavigate } from "react-router-dom"
import { useMemo } from "react"
import NoObjectsMessage from "./NoObjectsMessage"

export default function ObjectsInfo() {
    const navigate = useNavigate()
    const { objectFeatures, expandedKeys } = useAppSelector(state => state.objectsOnMapPointInfo) ?? {}
    const objectsInfoTree = useMemo(() => configureObjectsInfoTree(objectFeatures), [])

    function onSelect(event: TreeEventNodeEvent) {
        const node: any = event.node
        const link = node.link
        if (link) {
            navigate(link)
        }
    }

    return (
        <div className="objects-info-div">
            <strong>Информация по направлениям:</strong>
            <div>
                {Object.entries(objectsInfoTree).map(([roadAndPath, objectTypesTree]: any) => {
                    return (
                        <Accordion className="objects-accordion" multiple activeIndex={[0]} key={roadAndPath}>
                            <AccordionTab header={objectsInfoAccordionHeaderTemplate(roadAndPath)}>
                                <Tree className="objects-tree" expandedKeys={expandedKeys?.[roadAndPath]} value={configureObjectTypesTreeNodes(roadAndPath, objectTypesTree)} nodeTemplate={objectTypesTreeNodeTemplate} selectionMode="single" onSelect={onSelect} />
                            </AccordionTab>
                        </Accordion>
                    )
                })}
                {Object.keys(objectsInfoTree).length === 0 && <NoObjectsMessage />}
            </div>
        </div>
    )
}
